import Icon from '@/asset/Icon'
import { getSelectionCoords, isValidUrl } from '@/util'
import { LinkNode, TOGGLE_LINK_COMMAND } from '@lexical/link'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getNearestNodeOfType, mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection } from 'lexical'
import { useCallback, useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

type LinkState = {
  show: boolean
  top: number
  left: number
  url: string
}

export default function ToggleLinkUIPlugin() {
  const [editor] = useLexicalComposerContext()
  const [linkState, setLinkState] = useState<LinkState>({
    show: false,
    top: 0,
    left: 0,
    url: '',
  })

  const updateUI = useCallback(() => {
    const selection = $getSelection()
    if (!$isRangeSelection(selection)) return

    const anchorLink = $getNearestNodeOfType(selection.anchor.getNode(), LinkNode)
    const focusLink = $getNearestNodeOfType(selection.focus.getNode(), LinkNode)
    if (!anchorLink || !focusLink || anchorLink !== focusLink) return

    const linkNode = anchorLink

    const startOffset = selection.anchor.offset
    const endOffset = selection.focus.offset
    const linkLength = linkNode.getTextContentSize()

    if (
      (startOffset === 0 && endOffset === linkLength) ||
      (endOffset === 0 && startOffset === linkLength)
    ) {
      const coords = getSelectionCoords()
      setLinkState({
        show: true,
        url: linkNode.getURL(),
        top: coords.top,
        left: coords.left,
      })
    }
  }, [])

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => updateUI())
      })
      /*
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        (_payload, _newEditor) => {
          updateUI()
          return false
        },
        COMMAND_PRIORITY_LOW
      )
        */
    )
  }, [editor, updateUI])

  return (
    <>
      <Button
        key="link"
        onClick={() => {
          // const url = prompt('Enter URL:')
          // if (!url) return
          // editor.dispatchCommand(TOGGLE_LINK_COMMAND, url)
          const coords = getSelectionCoords()
          if (coords.isCollapsed) return
          setLinkState({ top: coords.top, left: coords.left, show: true, url: '' })
        }}
        variant="outline-secondary"
      >
        <Icon type="link" />
      </Button>
      <Modal
        centered
        show={linkState.show}
        onHide={() => {
          setLinkState((state) => ({ ...state, show: false, url: '' }))
        }}
      >
        <Modal.Header closeButton>
          <strong className="me-auto">URL</strong>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="url-input-form" label="リンクを入力してください">
            <Form.Control
              value={linkState.url}
              onChange={(e) => setLinkState((state) => ({ ...state, url: e.target.value }))}
            />
          </FloatingLabel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              editor.dispatchCommand(TOGGLE_LINK_COMMAND, linkState.url)
              editor.update(() => {
                const selection = $getSelection()
                if (!$isRangeSelection(selection)) return
                const node = $getNearestNodeOfType(selection.focus.getNode(), LinkNode)
                if (node) {
                  node.selectEnd()
                }
              })
              setLinkState({ top: 0, left: 0, show: false, url: '' })
            }}
            disabled={!isValidUrl(linkState.url)}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
